import React from 'react';

// -----------Importar Componentes de Terceros------------------
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';


const SelectMui = ({FontSize= { xs: '13px', sm: '16px' } , HandleChangeSingle, data, OnChange, name, MensajePersonalizado, defaultselect }) => {

    const handleChange = (event) => {
        if (event.target.value === 50) {
            MensajePersonalizado.function(true, MensajePersonalizado.key);
            OnChange(event);
        }
        else {
            MensajePersonalizado.function(false, MensajePersonalizado.key);
            OnChange(event);
        }

    }

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            HandleChangeSingle(true, 'formMemoria', 'MensajeValidate')
        }
    }


    return (
        <>
            <FormControl sx={{ width: { xs: '100%', sm: '100%', padding:'0px !important'} }}>
                <Select sx={{lineHeight:'0!important', padding: '10px 5px 5px 5px', "& .MuiSelect-icon": { color: '#D14081' }, '& .MuiSelect-select': { padding: '10px 5px 5px 5px' }, fontSize:FontSize }} width='100%' displayEmpty onChange={handleChange} name={name} value={defaultselect[name] === '' ? '' : defaultselect[name]} >
                    <MenuItem value="">
                        <em>
                            <Typography color='black' fontSize={FontSize}  display="inline" lineHeight='0 !important' >Selecciona o escribe tu mensaje.</Typography> 
                            {/* <Typography color='#D14081' fontSize={FontSize}   lineHeight='0 !important' display="inline">escribe tu mensaje.</Typography> */}
                        </em>
                    </MenuItem>
                    {
                        data.map((item, index) => (
                            <MenuItem sx={{ fontSize:FontSize }} key={index} value={item.value}>{item.label}</MenuItem>
                        ))
                    }

                </Select>
            </FormControl>

            {
                MensajePersonalizado.MensajePersonalizado === true
                    ?
                    <>
                        <textarea className="form-control mt-2" onKeyDown={onKeyDown} onChange={OnChange} width='100%' name='mensajepersonalizado' defaultValue={defaultselect.mensajepersonalizado} placeholder='Mensaje' id="bootstrap-input1"
                            multiline
                            rows={3}></textarea>
                    </>

                    : <></>
            }
        </>



    );
}


export default SelectMui